/**
 * FormKit — общие поля форм модалок (лейбл, инпут 44px, стаб-селект).
 * Единый вид полей в CreateAccount и модалках карточки клиента.
 */

import type {InputHTMLAttributes, ReactNode} from 'react';
import {ChevronDown} from 'lucide-react';

import {cn} from '@lib/utils';

export const Field = ({
  label,
  className,
  children,
}: {
  label: string;
  className?: string;
  children: ReactNode;
}) => (
  <div className={cn('flex flex-col gap-1.5', className)}>
    <span className="text-[12.5px] font-semibold text-skr-ink2">{label}</span>
    {children}
  </div>
);

type TextInputProps = InputHTMLAttributes<HTMLInputElement> & {mono?: boolean};

export const TextInput = ({mono, className, ...props}: TextInputProps) => (
  <input
    className={cn(
      'h-11 rounded-[10px] border border-input px-[13px] text-sm outline-none placeholder:text-muted-foreground focus:border-primary focus:ring-[3px] focus:ring-primary/12',
      mono && 'font-mono',
      className,
    )}
    {...props}
  />
);

/** Нефункциональный «селект» (как в макете — просто вид). */
export const SelectStub = ({placeholder, value}: {placeholder?: string; value?: string}) => (
  <button
    type="button"
    className="flex h-11 items-center justify-between rounded-[10px] border border-input px-[13px] text-sm outline-none"
  >
    <span className={value ? '' : 'text-muted-foreground'}>{value ?? placeholder}</span>
    <ChevronDown className="size-4 text-muted-foreground/70" strokeWidth={2} />
  </button>
);
